import { BackgroundCheckQuota } from '@/backend/features/background-check/defaults';
import { BackgroundCheckAnalytics } from '@/backend/features/background-check/shared';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export interface BackgroundCheckSummaryHeadingProps {
    analytics: BackgroundCheckAnalytics;
    quota?: BackgroundCheckQuota;
}

export const BackgroundCheckSummaryHeading: React.FC<BackgroundCheckSummaryHeadingProps> = ({ analytics, quota }) => {
    const { t } = useTranslation();
    const quotaLeft = quota ? Number(quota[analytics.type]?.quota) - Number(analytics.quotaUsed) : null;
    const { backgroundCheckConfig } = useSelector(getSettings);

    return (
        <Stack direction='row' sx={{ p: 2, justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant='subtitle2'>{backgroundCheckConfig?.type?.[analytics.type]?.label || ''}</Typography>
            {quota && quota[analytics.type]?.enabled && analytics.isJasSearch && (
                <Box sx={{ display: 'inline-flex', gap: 0.5 }} data-test='total-submitted-content'>
                    <Typography variant='body2'>
                        {t('pages.screenings.backgroundChecks.totalSubmitted', { quantity: analytics.totalSubmitted })}
                    </Typography>
                    <Typography variant='body2' color={themeColors.accent.red.bold}>
                        {t('pages.screenings.backgroundChecks.quotaLeft', { quotaLeft: quotaLeft })}
                    </Typography>
                </Box>
            )}
        </Stack>
    );
};
